import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

export interface CourseCreationErrorDialogData {
  errorMessage: string;
}

@Component({
  selector: 'app-course-creation-error-dialog',
  templateUrl: './course-creation-error-dialog.component.html',
  styleUrls: ['./course-creation-error-dialog.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
  ],
})
export class CourseCreationErrorDialogComponent {
  readonly dialogRef = inject(MatDialogRef<CourseCreationErrorDialogComponent>);
  readonly data = inject<CourseCreationErrorDialogData>(MAT_DIALOG_DATA);

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onTryAgain(): void {
    this.dialogRef.close(true);
  }
}
